var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_22623)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#0274B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9983 30H25.8573V23.5037C25.8573 21.9546 25.8297 19.9605 23.7036 19.9605C21.5468 19.9605 21.2168 21.6483 21.2168 23.3909V29.9996H17.0759V16.6406H21.0512V18.4662H21.1068C21.5047 17.7848 22.0796 17.2243 22.7703 16.8443C23.461 16.4643 24.2416 16.279 25.0291 16.3083C29.2262 16.3083 30 19.0738 30 22.6715L29.9983 30ZM12.4035 14.8145C11.9282 14.8146 11.4636 14.6735 11.0683 14.4091C10.6731 14.1446 10.3651 13.7687 10.1831 13.3289C10.0011 12.889 9.95345 12.405 10.0461 11.9381C10.1387 11.4711 10.3675 11.0421 10.7035 10.7054C11.0396 10.3687 11.4677 10.1393 11.9338 10.0463C12.4 9.95337 12.8831 10.001 13.3223 10.1831C13.7614 10.3652 14.1368 10.6737 14.4009 11.0695C14.665 11.4653 14.806 11.9307 14.8061 12.4068C14.8062 12.723 14.7441 13.036 14.6233 13.3281C14.5026 13.6202 14.3257 13.8856 14.1026 14.1091C13.8795 14.3327 13.6146 14.5101 13.3231 14.6311C13.0315 14.7521 12.7191 14.8145 12.4035 14.8145ZM14.474 30H10.3287V16.6406H14.474V30Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_22623"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin2);
export default __webpack_public_path__ + "static/media/linkedin-2.0cb7d64e8b64e46b5c91134c650277ee.svg";
export { ForwardRef as ReactComponent };